import type { ReactNode } from 'react';

export interface CardProps {
  className?: string;
  children: ReactNode;
}

export function Card({ className, children }: CardProps) {
  return (
    <div
      className={[
        'bg-card border border-border rounded-lg',
        className,
      ].filter(Boolean).join(' ')}
    >
      {children}
    </div>
  );
}
